import React, { useEffect, Fragment, useRef } from "react";
import { useAppContext } from "../../../libs/contextLib";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SearchTag from "../../helperComponents/searchTags";
import SelectDomainArea from "../../helperComponents/selectDomainArea";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@material-ui/icons/Info";
import moment from "moment";
import SearchUserAdvanced from "../../helperComponents/searchUserAdvanced";
import Slide from "@material-ui/core/Slide";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@material-ui/core/Checkbox";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Badge from "@material-ui/core/Badge";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import { AssessmentService } from "../../../services/assessment";
import { AssessmentSummaryService } from "../../../services/assessmentSummary";
import Fade from "@material-ui/core/Fade";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Factory } from "../../../helpers/factories";
import { OpenAIService } from "../../../services/openAI";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  filterElements: {
    marginLeft: "16px",
    marginRight: "16px",
    width: "90%",
  },
  appBar: {
    position: "relative",
  },
  textField: {
    "& > *": {
      fontSize: "14px",
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AddEditAsssessmentSummary({
  assessmentSummary,
  setAssesmentSummary,
  assessmentSummaries,
  setAssessmentSummaries,
  selectedDomainRoadmapIndex,
  opType,
  setOpType,
  isAddEditAssessmentSummaryDialogOpen,
  handleCloseAddEditAssessmentSummaryDialog,
  toastOptions,
  setToastOptions,
  handleCloseToast,
  ...props
}) {
  const { currentUser } = useAppContext();

  const classes = useStyles();

  const [isViewReset, setIsViewReset] = React.useState(false);

  //assessments
  const [assessments, setAssessments] = React.useState([]);
  const [formattedAssessments, setFormattedAssessments] = React.useState("");

  //grade
  const [gradeDuringSummary, setGradeDuringSummary] = React.useState(null);

  //summary
  const [summary, setSummary] = React.useState("");

  //query string
  const [queryString, setQueryString] = React.useState({
    from: null,
    to: null,
  });

  //view booleans
  const [gettingSummary, setGettingSummary] = React.useState(false);
  const [showAssessmentsArea, setShowAssessmentsArea] = React.useState(false);
  const [showGetSummaryBtn, setGetShowSummaryBtn] = React.useState(false);
  const [showSummaryArea, setShowSummaryArea] = React.useState(false);
  const [showSaveSummaryBtn, setShowSaveSummaryBtn] = React.useState(false);
  const [showSaveSummaryArea, setShowSaveSummaryArea] = React.useState(false);
  const [showConfirmSaveBtn, setShowConfirmSaveBtn] = React.useState(false);

  //scroll into view
  const refFilterArea = useRef(null);

  //assessment word  counter
  const [assessmentsWordCount, setAssessmentsWordCount] = React.useState(0);
  const [summaryWordCount, setSummaryWordCount] = React.useState(0);

  //temp assessmentSummary state to prevent lag
  const [tempAssessmentSummary, setTempAssessmentSummary] =
    React.useState(assessmentSummary);

  //populating year dropdwon
  const currentYear = moment().year();
  const yearArray = Array.from(
    Array(currentYear - (currentYear - 2)),
    (_, i) => currentYear - i
  );

  //
  const [user, setUser] = React.useState(null);
  const [userQueryOptions, setUserQueryOptions] = React.useState({});

  //for search domain component
  const [domainArea, setDomainArea] = React.useState(null);

  //dates of assessments
  const [assessmentFrom, setAssessmentFrom] = React.useState(
    moment().subtract(30, "days").startOf("day")
  );
  const [assessmentTo, setAssessmentTo] = React.useState(moment().endOf("day"));
  const [fromDateValid, setFromDateValid] = React.useState(true);
  const [toDateValid, setToDateValid] = React.useState(true);

  //confirm read summary
  const [checkedConsent, setCheckedConsent] = React.useState(false);

  //remarks
  const [remarks, setRemarks] = React.useState("");

  //for keeping some values when using save and new; saves from typing
  const [keepValues, setKeepValues] = React.useState(false);

  //load lesson plan if edit
  useEffect(() => {
    setTempAssessmentSummary(Factory.createAssessmentSummary());
    setDomainArea(null);
    setAssessments([]);
    setSummary("");
    setAssessmentFrom(moment().subtract(30, "days").startOf("day"));
    setUser(null);
    setAssessmentTo(moment().endOf("day"));
    setShowAssessmentsArea(false);
    setShowSummaryArea(false);
    setShowSaveSummaryArea(false);
  }, [opType]);

  //clear assessment area if domain or user changed
  useEffect(() => {
    setShowAssessmentsArea(false);
  }, [user, domainArea]);

  // assessment word count
  useEffect(() => {
    //collect commments from assessments
    let temp = assessments.reduce((result, assessment) => {
      return result + assessment.comment + "\n\n";
    }, "");
    setAssessmentsWordCount(temp.split(" ").length);
    setFormattedAssessments(temp);
  }, [assessments]);

  // summary word count
  useEffect(() => {
    setSummaryWordCount(summary.split(" ").length);
  }, [summary]);

  //wordcount warning
  useEffect(() => {
    if (assessmentsWordCount > 3000) {
      setToastOptions({
        ...toastOptions,
        open: true,
        message:
          "For best results, the total assessments word count should be less than 3000.",
      });
    }
  }, [assessmentsWordCount]);

  //get assessments
  async function getAssessments() {
    //get current page and for query string
    let qs = {
      ...queryString,
      student: user ? user._id : "",
      domainArea: domainArea ? domainArea._id : "",
      from: assessmentFrom ? assessmentFrom : "",
      to: assessmentTo ? assessmentTo : "",
    };
    setShowAssessmentsArea(true);

    try {
      const data = await AssessmentService.getAssessmentsByOrgId(
        currentUser.organisation.id,
        qs
      );
      setAssessments(data);
    } catch (err) {
      return new Promise((reject) => {
        reject(err);
      });
    }
  }

  //get summary
  async function getSummary() {
    //collect commments from assessments
    let temp = assessments.reduce((result, assessment) => {
      return result + assessment.comment + "\n\n";
    }, "");

    try {
      const data = await OpenAIService.getSummary(currentUser.organisation.id, {
        data: temp,
      });
      setShowSummaryArea(true);
      setGettingSummary(false);
      setSummary(data.summary);
    } catch (err) {
      setShowSummaryArea(false);
      setGettingSummary(false);

      // saving message
      setToastOptions({
        ...toastOptions,
        open: true,
        message: err.message,
      });

      return new Promise((reject) => {
        reject(err);
      });
    }
  }

  function enableGetAssessmentsButton() {
    return (
      user &&
      user._id &&
      domainArea &&
      domainArea._id &&
      fromDateValid &&
      toDateValid &&
      !showSummaryArea
    );
  }

  function handleSummaryChange(e) {
    setSummary(e.target.value);
  }

  const handleCheckedConsent = (event) => {
    setCheckedConsent(event.target.checked);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  //handle From date change
  const handleFromDateChange = (date) => {
    if (JSON.stringify(date) === "null") {
      setFromDateValid(false);
    } else {
      setAssessmentFrom(date);
      setFromDateValid(true);
      setQueryString({
        ...queryString,
        from: moment(date),
      });
    }
  };

  //handle To date change
  const handleToDateChange = (date) => {
    if (JSON.stringify(date) === "null") {
      setToDateValid(false);
    } else {
      setAssessmentTo(date);
      setToDateValid(true);
      setQueryString({
        ...queryString,
        to: moment(date),
      });
    }
  };

  //handle save summary
  const handleSaveSummary = async () => {
    // saving message
    setToastOptions({
      ...toastOptions,
      open: true,
      message: "Saving",
    });

    try {
      //prepare data
      var data = {
        organisation: currentUser.organisation.id,
        teacher: currentUser.id,
        student: user._id,
        domainArea: domainArea._id,
        gradeDuringSummary: gradeDuringSummary,
        summary: summary,
        remarks: remarks,
        assessmentFrom: assessmentFrom,
        assessmentTo: assessmentTo,
        isAutoGenerated: false,
      };

      const savedAssessmentSummary =
        await AssessmentSummaryService.addAssessmentSummaryByOrgId(
          currentUser.organisation.id,
          data
        );

      setShowSaveSummaryArea(false);
      setShowSummaryArea(false);
      setShowAssessmentsArea(false);

      setSummary("");
      setAssessments([]);

      //update datagrid
      let temp = [...assessmentSummaries];
      temp.forEach((item, index) => {
        item["id"] = index + 1;
      });
      temp.unshift(savedAssessmentSummary);
      setAssessmentSummaries(temp);

      setToastOptions({
        ...toastOptions,
        open: true,
        message: "Summary Saved",
      });
      refFilterArea.current?.scrollIntoView({
        behavior: "smooth",
      });
    } catch (err) {
      setToastOptions({
        ...toastOptions,
        open: true,
        message: err.message,
      });
    }
  };

  //const { title } = dialogPropsMain;
  // setDialogProps(row);
  return (
    <Fragment>
      <Dialog
        fullScreen
        open={isAddEditAssessmentSummaryDialogOpen}
        onClose={handleCloseAddEditAssessmentSummaryDialog}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseAddEditAssessmentSummaryDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {opType === "add" ? "Create Summary" : "Edit Summary"}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <Grid
            container
            spacing={3}
            style={{ justifyContent: "center", marginBottom: "32px" }}
          >
            <Grid item xs={10} ref={refFilterArea}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <SearchUserAdvanced
                    label={"Select a student"}
                    user={user}
                    setUser={setUser}
                    userQueryOptions={userQueryOptions}
                    setUserQueryOptions={setUserQueryOptions}
                    style={{ display: "flex" }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={10}>
              <Grid container>
                <Grid item xs={12} sm={3}>
                  <SelectDomainArea
                    domainArea={domainArea}
                    setDomainArea={setDomainArea}
                    showAllOption={false}
                    orgId={currentUser.organisation.id}
                    style={{ display: "flex" }}
                    type={""}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.filterElements}
                      inputVariant="outlined"
                      margin="normal"
                      id="date-picker-dialog-from"
                      label="Assessments From"
                      format="dd/MM/yyyy"
                      value={assessmentFrom}
                      onChange={handleFromDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.filterElements}
                      inputVariant="outlined"
                      margin="normal"
                      id="date-picker-dialog-from"
                      label="Assessments To"
                      format="dd/MM/yyyy"
                      value={assessmentTo}
                      onChange={handleToDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid itex xs={12} sm={2}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{ width: "90%" }}
                  >
                    <Button
                      style={{ height: "56px" }}
                      onClick={() => {
                        getAssessments();
                      }}
                      color="primary"
                      variant="contained"
                      size="small"
                      type="submit"
                      disabled={!enableGetAssessmentsButton()}
                    >
                      Get Assessments
                    </Button>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            {/* 
            Assessments 
            */}
            <Fade in={showAssessmentsArea} timeout={1500}>
              <Grid item xs={10}>
                <Grid container>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <Typography variant="h6" style={{ display: "inline" }}>
                      Assessments
                    </Typography>
                    <Badge
                      badgeContent={assessments.length}
                      color="primary"
                      style={{ marginLeft: "6px", marginBottom: "6px" }}
                    >
                      <LibraryBooksIcon />
                    </Badge>
                  </Grid>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <Typography variant="subtitle2">
                      Please make sure there is no existing summary of the
                      assessments for the given date range. Otherwise we will
                      have problems with data duplication and incur unnecessary
                      costs.{" "}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={9}
                    style={{ margin: "16px -16px 16px 16px" }}
                  >
                    <TextField
                      multiline
                      margin="dense"
                      id="assessments"
                      name="assessments"
                      label="Assessments"
                      type="text"
                      minRows={10}
                      className={classes.textField}
                      disabled={showSummaryArea}
                      value={formattedAssessments}
                      variant="outlined"
                      style={{ width: "97%" }}
                      fullWidth
                    />
                    <Typography variant="body1" style={{ marginTop: "8px" }}>
                      ({assessmentsWordCount} words )
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    style={{ margin: "8px 0px 16px 0px" }}
                  >
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "90%" }}
                    >
                      <Button
                        onClick={() => {
                          setGettingSummary(true);
                          getSummary();
                        }}
                        color="primary"
                        variant="contained"
                        size="medium"
                        type="submit"
                        disabled={
                          assessments.length < 1 ||
                          showSummaryArea ||
                          gettingSummary
                        }
                      >
                        Generate Summary
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
            {/* 
            Summary 
            */}
            <Fade in={showSummaryArea} timeout={1500}>
              <Grid
                item
                xs={10}
                // style={{
                //   display: (() => {
                //     return showSummaryArea ? "block" : "none";
                //   })(),
                // }}
              >
                <Grid container>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <Typography variant="h6">Summary</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={9}
                    style={{ margin: "16px -16px 16px 16px" }}
                  >
                    <TextField
                      multiline
                      margin="dense"
                      id="focusArea"
                      name="focusArea"
                      label="Summary"
                      type="text"
                      minRows={6}
                      className={classes.textField}
                      value={summary}
                      onChange={handleSummaryChange}
                      variant="outlined"
                      style={{ width: "97%" }}
                      disabled={showSaveSummaryArea}
                      fullWidth
                    />
                    <Typography variant="body1" style={{ marginTop: "8px" }}>
                      ({summaryWordCount} words )
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    style={{ margin: "8px 0px 16px 0px" }}
                  >
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "90%" }}
                    >
                      <Button
                        onClick={() => {
                          setShowSaveSummaryArea(true);
                        }}
                        color="primary"
                        variant="contained"
                        size="medium"
                        type="submit"
                        disabled={showSaveSummaryArea || summary.length < 1}
                      >
                        Next
                      </Button>
                      <Button
                        style={{ marginTop: "8px" }}
                        onClick={() => {
                          setSummary("");
                          setShowSummaryArea(false);
                        }}
                        color="primary"
                        variant="contained"
                        size="medium"
                        type="submit"
                        disabled={showSaveSummaryArea}
                      >
                        Back
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
            {/* 
            Save Summary 
            */}
            <Fade in={showSaveSummaryArea} timeout={1500}>
              <Grid item xs={10}>
                <Grid container>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <Typography variant="h6">Save Summary</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <Typography variant="subtitle2">
                      Note: Once saved, you will not be able to EDIT or DELETE
                      the summary.{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} style={{ margin: "16px" }}>
                    <FormControl component="fieldset">
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          value="end"
                          control={
                            <Checkbox
                              color="primary"
                              onChange={handleCheckedConsent}
                              checked={checkedConsent}
                            />
                          }
                          label="I have read the auto-generated summary and have made any changes necessary so that the summary 
                        is an acuurate reflection of the student's assessments. I have also added some remarks about the quality of the auto-generated summary."
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "90%" }}
                    >
                      <InputLabel id="type-description">
                        Current Grade of Student
                      </InputLabel>
                      <Select
                        labelId="grade"
                        id="grade"
                        name="grade"
                        value={gradeDuringSummary}
                        onChange={(e) => {
                          setGradeDuringSummary(e.target.value);
                        }}
                        label="Current Grade of Student"
                      >
                        <MenuItem value={"0"}>PP</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                        <MenuItem value={"4"}>4</MenuItem>
                        <MenuItem value={"5"}>5</MenuItem>
                        <MenuItem value={"6"}>6</MenuItem>
                        <MenuItem value={"7"}>7</MenuItem>
                        <MenuItem value={"8"}>8</MenuItem>
                        <MenuItem value={"9"}>9</MenuItem>
                        <MenuItem value={"10"}>10</MenuItem>
                        <MenuItem value={"11"}>11</MenuItem>
                        <MenuItem value={"12"}>12</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={9}
                    style={{ margin: "16px -16px 16px 16px" }}
                  >
                    <TextField
                      multiline
                      margin="dense"
                      id="focusArea"
                      name="focusArea"
                      label="Remarks"
                      type="text"
                      rows={4}
                      value={remarks}
                      onChange={handleRemarksChange}
                      variant="outlined"
                      style={{ width: "97%" }}
                      fullWidth
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    style={{ margin: "8px 0px 16px 0px" }}
                  >
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: "90%" }}
                    >
                      <Button
                        onClick={handleSaveSummary}
                        color="primary"
                        variant="contained"
                        size="medium"
                        type="submit"
                        disabled={
                          !checkedConsent ||
                          remarks.length < 1 ||
                          gradeDuringSummary == null
                        }
                      >
                        Save
                      </Button>
                      <Button
                        style={{ marginTop: "8px" }}
                        onClick={() => {
                          setShowSaveSummaryArea(false);
                        }}
                        color="primary"
                        variant="contained"
                        size="medium"
                        type="submit"
                      >
                        Back
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
          </Grid>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

export default AddEditAsssessmentSummary;
